import { EVENT_DEFAULTS, type CampaignConfig, type RaffleStatus } from "../../shared/src/config";

const allowedStatuses: RaffleStatus[] = ["PRELAUNCH", "PROMOTIONAL", "LIVE", "CLOSED", "RESULTS"];

function raffleStatus(value: string | undefined): RaffleStatus {
  const normalized = value?.toUpperCase() as RaffleStatus | undefined;
  return normalized && allowedStatuses.includes(normalized) ? normalized : "PROMOTIONAL";
}

function optionalNumber(value: string | undefined): number | null {
  if (!value) return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
}

export const campaignConfig: CampaignConfig = {
  ...EVENT_DEFAULTS,
  permitNumber: import.meta.env.VITE_PERMIT_NUMBER || EVENT_DEFAULTS.permitNumber,
  raffleStatus: "RESULTS",
  winnerPresenceRule: EVENT_DEFAULTS.winnerPresenceRule,
  eligibility: EVENT_DEFAULTS.eligibility,
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL || EVENT_DEFAULTS.contactEmail,
  contactPhone: import.meta.env.VITE_CONTACT_PHONE || EVENT_DEFAULTS.contactPhone,
  communityImpactUrl: import.meta.env.VITE_COMMUNITY_IMPACT_URL || EVENT_DEFAULTS.communityImpactUrl,
  mainSllUrl: import.meta.env.VITE_MAIN_SLL_URL || EVENT_DEFAULTS.mainSllUrl,
  liveJotformUrl: "",
  aggregateTotalEndpoint: "",
  officialRulesPdf: import.meta.env.VITE_OFFICIAL_RULES_PDF || "/official-rules.pdf",
  winnerAnnouncement: import.meta.env.VITE_WINNER_ANNOUNCEMENT || "",
  winningTicketNumber: "001999",
  finalTicketSales: optionalNumber(import.meta.env.VITE_FINAL_TICKET_SALES),
  analyticsId: import.meta.env.VITE_ANALYTICS_ID || "",
};

export function isValidCheckoutUrl(value: string): boolean {
  try {
    const url = new URL(value);
    const host = url.hostname.toLowerCase();
    return url.protocol === "https:" && !url.username && !url.password && (host === "jotform.com" || host.endsWith(".jotform.com"));
  } catch {
    return false;
  }
}

export function checkoutIsEnabled(config: CampaignConfig = campaignConfig): boolean {
  return config.raffleStatus === "LIVE" && isValidCheckoutUrl(config.liveJotformUrl);
}

export function publicCheckoutUrl(config: CampaignConfig = campaignConfig): string | null {
  return checkoutIsEnabled(config) ? config.liveJotformUrl : null;
}

